window.SMTX.FeatureCarousel = (function () {

  if ($('.feature-carousel').length === 0 || $('.feature-slick-text').length === 0) {
    return false;
  }


  var $_window = $(window);


  $('.feature-carousel').each(function () {
    var slick_text_clazz = '.' + $(this).find('.feature-slick-text').data('slick-id');
    var slick_image_clazz = '.' + $(this).find('.feature-slick-image').data('slick-id');
    var num_of_items = $(this).find('.feature-slick-text').data('num-of-items');
    //console.log(slick_text_clazz);


    $(slick_text_clazz).slick({
      slidesToShow: num_of_items,
      slidesToScroll: num_of_items,
      arrows: false,
      fade: false,
      dots: false,
      vertical: true,
      swipe: false,
      infinite: false,
      asNavFor: slick_image_clazz,
      waitForAnimate: false,
      adaptiveHeight: true,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            vertical: false,
            dots: false,
            fade: true,
            swipe: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            waitForAnimate: false,
          }
        }
      ]
    });

    $(slick_image_clazz).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: slick_text_clazz,
      dots: false,
      arrows: false,
      waitForAnimate: true,
      speed: 150,
      fade: true,
      focusOnSelect: false,
      autoplay: true,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
            fade: false,
            speed: 300
          }
        }
      ]
    }).on('breakpoint', function(event, slick, breakpoint) {
      // reload lottie players
      setTimeout(function() {
        $(slick_image_clazz).find('dotlottie-player').each(function() {
          var newPlayer = document.createElement('dotlottie-player');
          Array.from(this.attributes).forEach(attr => {
            newPlayer.setAttribute(attr.name, attr.value);
          });
          this.parentNode.replaceChild(newPlayer, this);
        });
      }, 300);
    });

    // click handlers, change slide
    $(document).on('mouseenter', ".feature-slick-text  .feature-text", function () {
      if (Foundation.MediaQuery.atLeast('large')) {
        var slide_index = $(this).data('slide-index');
        $(slick_image_clazz).slick('slickGoTo', slide_index);
      }
    });

    // click handlers, change slide
    $(document).on('click', ".feature-slick-text  .feature-text", function () {
      if (Foundation.MediaQuery.upTo('medium')) {
        $(slick_image_clazz).slick('slickNext');
      }
    });

  });

  function calculateSlickHeight() {
    $('.feature-slick-text').each(function () {
      var $me = $(this);
      var h = 0;

      $me.find('.slick-slide').each(function () {

        h += $(this).height();

      });
      
      if(window.innerWidth >= 1080){
        $me.css({ 'height': h + 6 });
      }else{
        $me.css({ 'height': 'auto'});
      }
    });
  }

  $_window.on('resize', calculateSlickHeight ).trigger('resize');

  return {

  };

})();
